/* Kollektionsseite  ·  Created By Ill
   Gehoert zu sections/cbi-collection.liquid.

   Ohne Javascript funktioniert die Seite trotzdem: die Filter stehen in einem
   ganz gewoehnlichen Formular, und der Knopf "Ergebnisse zeigen" schickt es
   ab. Diese Datei macht daraus nur den bequemeren Weg.

   Am Desktop wird sofort abgeschickt, sobald ein Haken gesetzt wird.
   Am Handy sammelt die Schublade die Haken und schickt erst beim Tippen auf
   "Ergebnisse zeigen" ab - sonst wuerde die Seite unter dem Finger neu laden.

   Alles haengt an EINEM Formular. Deshalb bleiben Sortierung und Filter
   zusammen erhalten, ohne dass irgendwo Adressen zusammengebaut werden. */

(function () {
  if (window.__cbiCollectionBound) return;
  window.__cbiCollectionBound = true;

  var MOBILE = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  function init(root) {
    if (!root || root.dataset.cbiBound === '1') return;
    root.dataset.cbiBound = '1';

    /* Sagt dem Stylesheet, dass es die Schublade geben darf. Ohne diese
       Klasse stehen die Filter untereinander in der Seite. */
    root.classList.add('is-js');

    var form = root.querySelector('[data-cbi-form]');
    var openBtn = root.querySelector('[data-cbi-open]');
    var closeBtn = root.querySelector('[data-cbi-close]');
    var veil = root.querySelector('[data-cbi-veil]');
    var pending = false;

    /* Leere Preisfelder wieder abschalten, damit sie nicht als min=&max=
       in der Adresse landen und dort wie ein gesetzter Filter aussehen. */
    function submit() {
      if (!form) return;
      var empties = form.querySelectorAll('input[type="number"]');
      for (var i = 0; i < empties.length; i++) {
        if (empties[i].value === '') empties[i].disabled = true;
      }
      root.setAttribute('aria-busy', 'true');
      form.submit();
    }

    /* ---- Aufklappen ---- */

    function closeAllPops(except) {
      var btns = root.querySelectorAll('[data-cbi-toggle]');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i] === except) continue;
        btns[i].setAttribute('aria-expanded', 'false');
        var pop = document.getElementById(btns[i].getAttribute('aria-controls'));
        if (pop) pop.hidden = true;
      }
    }

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cbi-toggle]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();

      var pop = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';

      if (!isMobile()) closeAllPops(btn);

      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (pop) pop.hidden = open;
    });

    document.addEventListener('click', function (event) {
      /* Schublade offen: jeder Klick daneben schliesst sie. Der Schleier
         allein reichte nicht - ein Tipp auf die Seite dahinter soll auch
         gehen, sonst muss man immer das Kreuz treffen. */
      if (root.classList.contains('is-open')) {
        var facets = root.querySelector('.cbi-c__facets');
        if (facets && facets.contains(event.target)) return;
        if (openBtn && openBtn.contains(event.target)) return;
        var bar = root.querySelector('.cbi-c__apply');
        if (bar && bar.contains(event.target)) return;
        drawer(false);
        return;
      }

      if (isMobile()) return;
      if (root.contains(event.target)) return;
      closeAllPops(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (root.classList.contains('is-open')) {
        drawer(false);
      } else {
        closeAllPops(null);
      }
    });

    /* ---- Schublade am Handy ---- */

    function drawer(open) {
      root.classList.toggle('is-open', open);
      document.body.classList.toggle('cbi-c-locked', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open && pending) submit();
    }

    if (openBtn) openBtn.addEventListener('click', function () { drawer(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { drawer(false); });
    if (veil) veil.addEventListener('click', function () { drawer(false); });

    var applyBtn = root.querySelector('[data-cbi-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function (event) {
        event.preventDefault();
        submit();
      });
    }

    /* ---- Aenderungen ---- */

    if (form) {
      form.addEventListener('change', function (event) {
        var el = event.target;
        if (!el.name) return;

        /* Felder mit data-cbi-single lassen nur einen Wert zu: wird ein
           Haken gesetzt, fallen die uebrigen im selben Feld weg. Aus der
           Liste zum Ankreuzen wird damit faktisch eine Auswahl unter
           mehreren - ohne die Namen der Felder zu aendern, an denen
           Shopifys Filter haengen. */
        if (el.type === 'checkbox' && el.checked && el.closest) {
          var pop = el.closest('[data-cbi-single]');
          if (pop) {
            var mates = pop.querySelectorAll('input[type="checkbox"]');
            for (var m = 0; m < mates.length; m++) {
              if (mates[m] !== el) mates[m].checked = false;
            }
          }
        }

        /* Sortierung schickt immer sofort ab, auch am Handy: sie steht
           ohnehin ausserhalb der Schublade. */
        if (el.name === 'sort_by' || !isMobile()) {
          submit();
          return;
        }
        pending = true;
      });

      /* Enter im Preisfeld soll abschicken statt nur das Feld zu verlassen. */
      form.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        if (event.target.type !== 'number') return;
        event.preventDefault();
        submit();
      });
    }

    /* ---- Endloses Nachladen ----

       Keine Seitenzahlen mehr: die naechste Seite haengt sich unten an,
       sobald man in ihre Naehe kommt.

       Die Leiste .cbi-c__pages bleibt im Markup stehen. Sie ist zweierlei:
       der Traeger der Adresse der naechsten Seite - und die Rueckfallebene,
       wenn dieses Script nicht laeuft. Sichtbar ist sie nur dann; die
       Klasse is-endless blendet sie aus, sobald hier uebernommen wird.

       Nachgeladen wird die fertige Seite und daraus nur die Karten
       herausgenommen. Kein eigener Datenweg, keine zweite Darstellung -
       was die Seite ohnehin liefert, wird angehaengt. */

    var list = root.querySelector('.cbi-grid__list');
    var pagesNav = root.querySelector('.cbi-c__pages');

    if (list && pagesNav && window.fetch && window.DOMParser) {
      root.classList.add('is-endless');

      var sentry = document.createElement('div');
      sentry.className = 'cbi-c__sentry';
      sentry.setAttribute('aria-hidden', 'true');
      sentry.style.minHeight = '1px';
      list.parentNode.appendChild(sentry);

      var busy = false;
      var io = null;

      function nextHref() {
        var a = pagesNav.querySelector('a[rel="next"]');
        return a ? a.href : '';
      }

      function watch() {
        if (!nextHref()) {
          if (sentry.parentNode) sentry.parentNode.removeChild(sentry);
          return;
        }
        if (io) io.observe(sentry);
      }

      function grow() {
        var url = nextHref();
        if (!url || busy) return;
        busy = true;
        root.setAttribute('aria-busy', 'true');

        window.fetch(url, { credentials: 'same-origin' })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var more = doc.querySelector('.cbi-grid__list');
            var nav = doc.querySelector('.cbi-c__pages');

            if (more) {
              while (more.firstElementChild) list.appendChild(more.firstElementChild);
            }

            /* Danach traegt die Leiste die Adresse der uebernaechsten Seite
               - oder keine mehr, dann ist die Kollektion zu Ende. */
            pagesNav.innerHTML = nav ? nav.innerHTML : '';

            busy = false;
            root.removeAttribute('aria-busy');
            watch();
          })
          .catch(function () {
            /* Geht das Nachladen schief, kommen die Seitenzahlen zurueck -
               dann klickt man eben weiter. */
            busy = false;
            root.removeAttribute('aria-busy');
            root.classList.remove('is-endless');
          });
      }

      if (window.IntersectionObserver) {
        io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              io.unobserve(sentry);
              grow();
            }
          }
        }, { rootMargin: '800px 0px' });
        watch();
      } else {
        /* Aeltere Browser: alle paar Pixel nachsehen, wie weit unten wir sind. */
        window.addEventListener('scroll', function () {
          if (busy || !nextHref()) return;
          if (sentry.getBoundingClientRect().top < window.innerHeight + 800) grow();
        });
      }
    }

    /* Beim Wechsel der Breite die Schublade aufraeumen, damit am Desktop
       kein gesperrter Koerper zurueckbleibt. */
    var mq = window.matchMedia(MOBILE);
    var onChange = function () {
      if (!isMobile() && root.classList.contains('is-open')) drawer(false);
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cbi-collection]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Im Theme-Editor wird die Section neu gezeichnet, ohne dass die Seite
     neu laedt. Dann muss die neue Huelle noch einmal verdrahtet werden. */
  document.addEventListener('shopify:section:load', boot);
})();
